import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
var DIMENSION_SM = '32px';
var DIMENSION_MD = '56px';
var DIMENSION_LG = '112px';
var variantOptions = {
  sm: {
    height: DIMENSION_SM,
    width: DIMENSION_SM,
    fontSize: '11px',
    lineHeight: DIMENSION_SM
  },
  md: {
    height: DIMENSION_MD,
    width: DIMENSION_MD,
    fontSize: '22px',
    lineHeight: DIMENSION_MD
  },
  lg: {
    height: DIMENSION_LG,
    width: DIMENSION_LG,
    fontSize: '44px',
    lineHeight: DIMENSION_LG
  }
};
export var AvatarWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n\n  height: ", ";\n  width: ", ";\n\n  div,\n  img {\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), function (_ref) {
  var size = _ref.size;
  return variantOptions[size].height;
}, function (_ref2) {
  var size = _ref2.size;
  return variantOptions[size].width;
}, function (_ref3) {
  var size = _ref3.size;
  return variantOptions[size].fontSize;
}, function (_ref4) {
  var size = _ref4.size;
  return variantOptions[size].lineHeight;
});